import { useRef } from "react";
import PropTypes from "prop-types";
import { Transition } from "react-transition-group";
import Alert from "@shared/v2/Alert";
import Button from "@shared/v2/Button";
import Checkbox from "@shared/v2/Checkbox";
import ShadowScroll from "@shared/v2/ShadowScroll";

const transitionStyles = {
  entering: "tw-opactiy-0 tw-max-h-0",
  entered: "tw-opacity-1 tw-max-h-[500px] tw-overflow-visible",
  exiting: "tw-opacity-0 tw-max-h-0",
  exited: "tw-opacity-0 tw-max-h-0 tw-mt-[-8px] tw-overflow-hidden",
};
const NoticeTwoPartyConsent = ({ showTwoPartyNotice, agreeTwoParty, setAgreeTwoParty }) => {
  const twoPartyRef = useRef(null);

  return (
    <Transition in={showTwoPartyNotice} nodeRef={twoPartyRef}>
      {(state) => (
        <div
          ref={twoPartyRef}
          className={`tw-transition-all tw-duration-300 tw-ease-linear ${transitionStyles[state]}`}
        >
          <Alert
            variant="warning"
            title="Notice: 2-Party Recording Consent Laws"
            text={
              <div className="tw-flex tw-flex-col tw-gap-[8px]">
                <ShadowScroll
                  className="tw-flex tw-flex-col tw-gap-[4px] tw-max-h-[116px]"
                  fromColor="tw-from-semantic-yellow-5"
                >
                  <div>
                    Certain countries, states, and jurisdictions require the consent of all parties to record
                    telephone conversations. By disabling the notification feature and subsequently recording
                    telephone conversations without providing proper notice and consent, you may be in
                    violation of federal and/or state law.
                  </div>
                  <div>
                    By selecting the &quot;I agree&quot; checkbox, the Brivity account owner agrees without
                    reservation or limitation, to defend, indemnify, and hold harmless Brivity Inc, its parent
                    companies, affiliates, and their respective directors, officers, employees, and agents
                    from and against any and all losses, damages, claims, liabilities, penalties, fines,
                    judgments, settlements, actions, suits, proceedings, litigation, investigations, legal
                    costs and expenses, and demands made by any party due to or arising out of the use of the
                    Brivity Dialer call recording feature by the Brivity account owner and/or his/her/its
                    employees, agents, affiliates, or representatives.
                  </div>
                </ShadowScroll>
                <div className="tw-flex tw-gap-[8px] tw-justify-between tw-items-center">
                  <Checkbox
                    label="I agree"
                    labelClassName="!tw-text-inherit"
                    checked={agreeTwoParty}
                    onChange={(e) => setAgreeTwoParty(e.target.checked)}
                  />
                  <Button
                    schema="secondary"
                    size="small"
                    className="!tw-text-semantic-yellow-120 !tw-border-inherit"
                    onClick={() =>
                      window.open("https://our.place.com/spaces/64/call-recording/call-recording", "_blank")
                    }
                  >
                    Learn More
                  </Button>
                </div>
              </div>
            }
          >
            Two party consent
          </Alert>
        </div>
      )}
    </Transition>
  );
};
NoticeTwoPartyConsent.propTypes = {
  setAgreeTwoParty: PropTypes.func,
  showTwoPartyNotice: PropTypes.bool,
  agreeTwoParty: PropTypes.bool,
};
NoticeTwoPartyConsent.defaultProps = {
  showTwoPartyNotice: false,
  agreeTwoParty: false,
  setAgreeTwoParty: () => {},
};
export default NoticeTwoPartyConsent;
